import { ContentPanel } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const ContentWrapper = styled(ContentPanel)`
  .MuiTableCell-head {
    padding-left: 16px;
  }
  tr td a:first-child {
    padding-left: 16px;
  }
`;
